export default __webpack_public_path__ + "static/media/travis-ci-icon.fee5d6ac.svg";